export let HOST = "https://bitsnap.pl";

export function setCustomHost(host: string) {
  HOST = host;
}
